import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        list: [],
        attr: {
            attrArr: [],
            attrKeys: '',
            subAttrKeys: ''
        },
        groupAttr: {
            groupAttrArr: [],
            groupAttrKeys: '',
            groupSubAttrKeys: ''
        },
        spec: {
            specItem: null,
            specKeys: ''
        },
        quantity: 1
    },
    reducers: {
        setProductAttr: (state, action) => {
            state.attr = action.payload
        },
        setProductGroupAttr: (state, action) => {
            state.groupAttr = action.payload
        },
        setProductSpec: (state, action) => {
            state.spec = action.payload
        },
        setQuantity: (state, action) => {
            state.quantity = action.payload
        },
        resetCart: (state) => {
            state.list = []
            state.attr = {
                attrArr: [],
                attrKeys: '',
                subAttrKeys: ''
            }
            state.groupAttr = {
                groupAttrArr: [],
                groupAttrKeys: '',
                groupSubAttrKeys: ''
            }
            state.spec = {
                specItem: null,
                specKeys: ''
            }
            state.quantity = 1
        }
    },
});

export const { setProductAttr, setProductGroupAttr, setProductSpec, resetCart, setQuantity } = cartSlice.actions;
export const selectProductAttr = (state) => state.cart.attr;
export const selectProductGroupAttr = (state) => state.cart.groupAttr;
export const selectProductSpec = (state) => state.cart.spec;
export const selectProductQuantity = (state) => state.cart.quantity;
export default cartSlice.reducer;
